/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_TemplateInputs */

const cs_property_legal_template = /** @type {(inputs: Property_Legal_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šablona`)
};

const en_property_legal_template = /** @type {(inputs: Property_Legal_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template`)
};

/**
* | output |
* | --- |
* | "Template" |
*
* @param {Property_Legal_TemplateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_template = /** @type {((inputs?: Property_Legal_TemplateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_TemplateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_template(inputs)
	return cs_property_legal_template(inputs)
});